import { useParams } from "react-router-dom";
import UserEdit from "screens/components/UserEdit"
import { useUrl }  from "lib/site"

function OrganisationUserEdit() {
    const { organisationId } = useParams();
    const getUrl = useUrl();
    return <UserEdit organisationId={organisationId} returnUrl={getUrl("OrganisationUsers")} />
}

export default OrganisationUserEdit;